import React from "react";
import axios from "axios";
import { Redirect } from "react-router-dom";

// Clean instance with no interceptors: the global axios force-redirects to
// /auth/login on any 401, which would hide the "reset link expired" message
// when the scope-restricted reset token is invalid/expired.
const resetClient = axios.create();

export default function changePassword(token, val) {
  const json = require("../../../config.json");
  const urlBase = json.urlBase;

  if (token) {
    // The reset link now carries a scope-restricted reset token (NOT a session
    // token). Exchange it at the dedicated set-password endpoint. This does NOT
    // log the user in — they must sign in with password + 2FA afterward.
    return resetClient.post(urlBase + "/auth/set-password", {
      reset_token: token.replace(/['"]+/g, ""),
      password: val,
    });
  } else {
    return <Redirect exact from="/" to="/logout" />;
  }
}
